import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'GLOBAL_SEARCH',
    icon: 'menu-global-search',
    label: '全局搜索',
    placement: 'bottom',
    path: '/global-search',
    public: true,
  },
] satisfies Menu[];
